// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XIC8","col":"styles_col__2lqWB","actions":"styles_actions__25L8d","conflict":"styles_conflict__2L5SU"};